export default "__VITE_ASSET__e606b253__"